module.exports = __webpack_public_path__ + "img/39.dcd879bb.png";